<template>
  <div>
    <router-view :key="this.$router.path" />
  </div>
</template>

<script>
var mixins = {
  computed: {
    isPc() {
      return this.$utils.browser();
    },
  },
  created() {
    if (!this.isPc) {
      location.href = location.origin + "/h5";
    }
  },
};

export default {
  mixins: [mixins],
};
</script>

<style lang="less">
@import "./assets/css/main.css";
body {
  display: block;
  margin: 0px;
}
.el-menu--horizontal {
  display: flex;
  flex-wrap: nowrap;
  border-right: none;
}
</style>
